webpackJsonp([136108828486757],{

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon2 = "https://winpeleadershipsummit.winpeforum.com/wp-content/uploads/2026/03/Untitled-design-1.png";
	var icon4 = "https://winpeforum.com/assets/elements/bhavna.png";
	var icon12 = "https://winpeforum.com/assets/elements/HardikaShah.jpg";
	
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/2july2026/1.jpg";
	var I2 = "https://www.winpeforum.com/assets/sheshines/2july2026/18.jpg";
	var I3 = "https://www.winpeforum.com/assets/sheshines/2july2026/3.jpg";
	var I4 = "https://www.winpeforum.com/assets/sheshines/2july2026/4.jpg";
	var I5 = "https://www.winpeforum.com/assets/sheshines/2july2026/18.jpg";
	var I6 = "https://www.winpeforum.com/assets/sheshines/2july2026/6.jpg";
	var I7 = "https://www.winpeforum.com/assets/sheshines/2july2026/7.jpg";
	var I8 = "https://www.winpeforum.com/assets/sheshines/2july2026/8.jpg";
	var I9 = "https://www.winpeforum.com/assets/sheshines/2july2026/19.jpg";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/1.jpg";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/18.jpg";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/3.jpg";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/4.jpg";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/18.jpg";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/6.jpg";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/7.jpg";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/8.jpg";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/2july2026/19.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon2,
	      desc: "<div>\n        Anjali Sosale is a GP at WaterBridge Ventures where she focuses on consumption and the gig economy. She was previous with Myntra Jabong and EY in leadership roles and is based in Bangalore. WaterBridge is a VC firm that partners with founders early, with a $1-3M cheque and continues to invest until Series C. \n          \n          </div>",
	      name: "AnjaIi Sosale",
	      post: "<div>Partner<br/> WaterBridge Ventures<br/>(Speaker)\n  \n  \n          </div>"
	    }, {
	      imgUrl: icon12,
	      desc: "As the solo founder of fintech Kinara Capital, Hardika is recognized social entrepreneur and a dedicated advocate of Financial Inclusion. With the pioneering use of AI and tech-enabled solutions, Kinara Capital advanced the lives of over 1 lakh small business owners across 100+ cities in India that in turn impacted over half a million lives in local economies with new job creation and income generation. <br/><br/>\n\nAs a purpose-driven entrepreneur, Hardika has been recognized for her leadership in building inclusive finance solutions and for championing gender equality in the workplace.  <br/><br/>\nHer accolades include being named among the Forbes India W-Power List of Top 20 Self-Made Women, receiving the Economic Times Startup Award, the United Nations award for Leadership, and national recognition by the Government of India as one of the Top 75 Women Entrepreneurs Transforming India.  <br/><br/>\nHardika has also been invited as a TEDx speaker, and her unique story has been featured by The Better India, Humans of Bombay, Mint newspaper, Entrepreneur magazine and more.  <br/><br/>\n\nBefore founding Kinara Capital, Hardika spent nearly two decades in Management Consulting working across the US, Europe, and Asia-Pacific, and mentoring social entrepreneurs through leading global institutions. <br/><br/>s\n\nHardika holds a Bachelor\u2019s degree in Computer Science from Knox College and an MBA from the joint program of Columbia Business School and UC Berkeley Haas School of Business.\n",
	      name: "Hardika Shah",
	      post: "<div>Founder & CEO <br/>Kinara Capital<br/>(Speaker)</div>"
	
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n      Bhavna Suresh is an entrepreneur renowned for attracting top-tier talent and architecting margin-centric, scalable strategies across the Asia-Pacific region. A lifelong learner, she thrives in collaborative environments alongside diverse experts and is dedicated to refining the art of deep listening.<br/><br/>\n\nIn 2020, she achieved a successful exit from a multi-million-dollar PropTech venture, a milestone reached alongside her exceptional team.<br/><br/>\n\nBhavna is deeply committed to cross-cultural collaboration, with a steadfast focus on driving inclusion and championing women\u2019s representation in the workforce.<br/><br/>\n\nShe is the founder of Stylebank and holds an MBA from HEC Paris, as well as an Engineering degree from VTU Bangalore.\n\n        \n        \n        </div>",
	      name: "Bhavna Suresh        ",
	      post: "<div>Venture Partner\n\n<br/>\n       Antler<br/>(Moderator)\n        \n  \n  \n        </div>"
	    }];
	
	    _this.Speaker2 = [];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 22, ImgSrc: I6, ImgSrc1: II6 }, { id: 19, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 34, ImgSrc: I9, ImgSrc1: II9 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "sheshines with Winpe "
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "July 2, 2026 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Bangalore International Centre (BIC), Bengaluru"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "h3",
	                null,
	                "The Honest Debrief \u2014 What We Got Wrong on Both Sides of the Table"
	              ),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On July 2, 2026, Winpe sheshines brought together women from the investing and entrepreneurial ecosystem for a candid conversation on the decisions, assumptions and turning points that shape a founder\u2019s and an investor\u2019s journey. Moving beyond polished success stories, the discussion explored how experience changes judgment and how leaders learn from difficult choices.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Event Highlights"
	              ),
	              " ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              "The discussion challenged the idea that every setback can be neatly labelled a failure. Speakers explored the assumptions behind difficult decisions, the role of trusted truth-tellers and the importance of taking a longer view of success and setbacks.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "A community poll had identified \u2018hiring the wrong people\u2019 as the most expensive startup mistake, opening a wider conversation on evolving teams, trust and leadership through change. The founder\u2013investor relationship was also examined candidly from understanding different forms of capital and investor constraints to retaining founder conviction. The conversation further touched on crisis, difficult conversations and loneliness in leadership.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Our Key Takeaways"
	              ),
	              "          ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Own the decision, not just the outcome"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Good reflection means understanding why you made a decision, not judging it only by what happened later.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Think in decades, not days"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "A single setback or success should not define a long journey. A wider time horizon brings perspective and equanimity.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Build a circle of trust \u2014 and let it evolve"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Leaders need truth-tellers who challenge assumptions honestly, while recognising that the advice required changes with each stage.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "The people who build may not be the people who stabilise"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Different phases call for different strengths. The team that drives growth may not always be best equipped for crisis or transition.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Understand the colour of capital"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Fund timelines, return expectations and institutional constraints shape investor behaviour. Understanding them early can prevent misalignment.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Investors can enable; founders must retain conviction"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Investors bring perspective and networks, but founders must continue to own operating judgment and key decisions.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Growth cannot cover fundamental cracks"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Scale cannot compensate for weak governance, unresolved people issues or structural fragility; it can amplify what remains unaddressed.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Loneliness has more than one form"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Leadership can be isolating in decisions, relationships and even at home. The support systems that sustain a long journey matter.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null)
	                )
	              ),
	              "The Honest Debrief offered a simple lens: understand why a decision was made, recognise when a belief needs to change and carry the learning forward. That spirit sits at the heart of sheshines creating a trusted space for women across the private equity, venture capital and entrepreneurial ecosystem to share experiences, exchange perspectives and build meaningful relationships."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "gallery/" },
	                _react2.default.createElement(
	                  "button",
	                  { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                  "View All Images"
	                ),
	                " "
	              ),
	              " "
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "row" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Speakers & Moderator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '65%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 3) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-2-july-2026-index-js-7fb1de3813b78b6e0248.js